import { EndCustomerAccountStatus } from "@api/graphql/generated/generated-types";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import { useCreateOrderContext } from "../utils/CreateOrderContextProvider";

export default function CustomerOnHoldWarning() {
  const { selectedCustomer } = useCreateOrderContext();

  if (
    selectedCustomer?.accountStatus !== EndCustomerAccountStatus.BlockOrderCreate
  )
    return null;

  return (
    <div className="flex items-start gap-2.5 rounded-r-md border-l-[3px] border-red-500 bg-red-500/10 p-2.5 dark:bg-red-500/[0.08]">
      <ExclamationTriangleIcon className="h-[18px] w-[18px] flex-shrink-0 text-red-500 mt-0.5" />
      <div>
        <div className="text-xs font-semibold text-red-500">
          Customer On Hold
        </div>
        <div className="text-xs text-red-400 dark:text-red-400 mt-0.5">
          This customer is on hold. Order creation is blocked and the order will
          be rejected.
        </div>
      </div>
    </div>
  );
}
